import { INavbarItem } from "./navbarTypes";

import { ReactComponent as HomeIco } from "assets/icons/new-home-ico.svg";
import { ReactComponent as AcademyIco } from "assets/icons/new-academy-ico.svg";
import { ReactComponent as EventIco } from "assets/icons/new-event-ico.svg";
import { ReactComponent as PlayerIco } from "assets/icons/new-player-ico.svg";
import { ReactComponent as ScannerIco } from "assets/icons/new-scanner-ico.svg";
import { ReactComponent as TrainerIco } from "assets/icons/new-trainer-ico.svg";
import { ReactComponent as StructureIco } from "assets/icons/new-structure-ico.svg";
import { ReactComponent as ShopIco } from "assets/icons/new-shop-ico.svg";
import { ReactComponent as ContactIco } from "assets/icons/new-contact-ico.svg";
import { ReactComponent as FilesIco } from "assets/icons/new-files-ico.svg";
import { ReactComponent as ConceptsIco } from "assets/icons/filesIco.svg";
import { ReactComponent as salesChannelIco } from "assets/icons/salesChannelIco.svg";
import { ReactComponent as ManagmentIco } from "assets/icons/new-managment-ico.svg";

import { ReactComponent as PostIcon } from "assets/icons/post-icon.svg";

export const getEventsPathWithDate = () => {
  const today = new Date();

  const threeDaysAgo = new Date();
  threeDaysAgo.setDate(today.getDate() - 3);

  const startYear = threeDaysAgo.getFullYear();
  const startMonth = (threeDaysAgo.getMonth() + 1).toString().padStart(2, "0");
  const startDay = threeDaysAgo.getDate().toString().padStart(2, "0");

  const startDate = `${startYear}-${startMonth}-${startDay}`;

  const threeDaysLater = new Date();
  threeDaysLater.setDate(today.getDate() + 3);

  const endYear = threeDaysLater.getFullYear();
  const endMonth = (threeDaysLater.getMonth() + 1).toString().padStart(2, "0");
  const endDay = threeDaysLater.getDate().toString().padStart(2, "0");

  const endDate = `${endYear}-${endMonth}-${endDay}`;

  return `/events?DateFrom=${startDate}&DateTo=${endDate}`;
};

export const navLinks: Array<INavbarItem> = [
  {
    label: "Klub",
    icon: StructureIco,
    path: "/structure",
  },
  {
    label: "Zajęcia",
    icon: EventIco,

    items: [
      {
        label: "Zajęcia",
        path: getEventsPathWithDate(),
      },
      {
        label: "Drafty",
        path: "/drafts",
      },
      {
        label: "Cykliczne",
        path: "/cyclical",
      },
    ],
  },
  {
    label: "Monitoring",
    icon: HomeIco,
    path: "/",
  },

  {
    label: "Zawodnicy",
    icon: PlayerIco,
    path: "/players",
  },
  {
    label: "Nabór",
    icon: ScannerIco,
    items: [
      {
        label: "Zgłoszenia",
        path: "/outside-players/requested",
      },
      {
        label: "Radar",
        path: "/outside-players/available",
      },
    ],
  },
  {
    label: "Trenerzy",
    icon: TrainerIco,
    path: "/trainers",
  },
  {
    label: "Rekrutacja trenerów",
    icon: ScannerIco,
    items: [
      {
        label: "Kandydaci",
        path: "/outside-trainers/requested",
      },
      {
        label: "Dostępni trenerzy",
        path: "/outside-trainers/available",
      },
    ],
  },
  {
    label: "Sklep",
    icon: ShopIco,
    items: [
      {
        label: "Wydarzenia płatne",
        path: "/shop/events",
      },
      {
        label: "Zamówienia",
        path: "/shop/orders",
      },
      {
        label: "Składki",
        path: "/shop/passes",
      },
      {
        label: "Kupony",
        path: "/shop/coupon",
      },
      {
        label: "Produkty",
        path: "/shop/products",
      },
      {
        label: "Kategorie",
        path: "/shop/categories",
      },
      {
        label: "Atrybuty",
        path: "/shop/attributes",
      },
      {
        label: "Dostawy",
        path: "/shop/delivery",
      },
    ],
  },
  {
    label: "Personel",
    icon: ContactIco,
    path: "/contacts",
  },
  {
    label: "Konspekty",
    icon: ConceptsIco,
    path: "/concepts",
  },
  {
    label: "Teczka",
    icon: FilesIco,
    path: "/files",
  },
  {
    label: "System",
    icon: AcademyIco,
    path: "/academy",
  },

  {
    label: "Dostępy",
    icon: ManagmentIco,
    path: "/users",
  },
  {
    label: "Posty",
    icon: PostIcon,
    path: "/posts",
  },
];
